export const defaultVersion = {
  prefix: 'v',
  number: 1
};

export const endpoints = {
  v1: {
    login: 'authentication/login/',
    refresToken: 'authentication/refresh-token/',
    category: 'category/{idCategoria}/',
    process: 'process/{idProceso}/',
    processCategory: 'process-category/{idCategoria}/',
    defaultTramites: 'default-tramites/{idTramite}/',
    defaultStatusTramite: 'default-status-tramite/',
    adminDefaultWorkflowTramite: 'admin-default-workflow-tramite/{idTramite}/',
    defaultStatusActivity: 'default-status-activity/',
    statusActivity: 'status-activity/',
    tramiteProcess: 'tramite-process/{idProceso}/',
    instanceDefaultTramite: 'instance-default-tramite/{idDefaultTramite}/',
    microprocesInstance: 'microproces-instance/{idTarea}/',
    instanceTramite: 'instance-tramite/{idTramite}/',
    instanceMethods: 'instance-methods/',
    assignment: 'task-assignment-responsible/',
    roles: 'roles/{idRol}/',
    rolesUsers: 'roles-users/{idRol}/',
    holidays: 'holidays/{idHoliday}/',
    specialDays: 'special-days/{idSpecialDay}/',
    docsInstance: 'document-instance/{idDocumento}/',
    historyDocsInstance: 'history-document-instance/{idDocumento}/',
    reviewDocument: 'review-document/',
    radication: 'radication-document/{idDocumento}/',
    typeField: 'type-fields/',
    dynamicForm: 'dynamic-form/{idForma}/',
    masterTable: 'master-table/{idMaster}/',
    dynamicFormInstance: 'dynamic-form-instance/{idTarea}/',
    typeTask: 'type-task/',
    defaultTypeTask: 'default-type-task/',
    statusTask: 'status-task/',
    defaultStatusTask: 'default-status-task/',
    defaultMicroproces: 'default-microproces/{idMicroproces}',
    defaultTypeCompletion: 'default-type-completion/{idType}/',
    typeCompletion: 'type-completion',
    defaultDocument: 'default-document/',
    defaultFunction: 'default-function/',
    typeAssociation: 'type-association/{id}/',
    taskTramiteDefault: 'task-tramite-default/{idTramite}/',
    masterTableInformation: 'master-table-information/{idMasterTable}/',
    activityCalendar: 'activity-calendar/{idUsuario}/',
    defaultTask: 'default-task/{id}/',
    structureMasterTable: 'structure-master-table/{idStructure}/',
    masterTableSpecificInformation: 'master-table-specific-information/',
    documentGeneration: 'document-generation/',
    chargeTaskData: 'charge-task-data/{idTask}/',
    duplicateDefaultTramite: 'duplicate-default-tramite/',
    radicationDocument: 'radication-document/{idTarea}/',
    dynamicReport: 'dynamic-report/',
    historyTask: 'history-task/{idTask}',
    rejectTask: 'reject-task/',
    reportTraceability: 'report-traceability/',
    usersManagement: 'users-management/{idUser}/',
    company: 'company/{id}/',
    emailSmtp: 'admin-email-smtp/{id}/',
    emailSmtpCompany: 'admin-email-smtp-company/{idCompany}/',
    sedesManagement: 'sedes-management/{idCompany}/',
    dependencies: 'dependencies/{id}/',
    chargeMasterData: 'charge-master-data/{idMaestra}/',
    historyMicroproces: 'history-microproces/{idTask}/',
    generateRadicationCita: 'generate-radication-cita/',
    workingDays: 'working-days/',
    synchronizationForms: 'synchronization-forms/{id}/',
    rolesPermissions: 'roles-permissions/{id}/',
    typePermissions: 'type-permissions/{idType}/',
    rolesTramite: 'roles-tramite/{idTramite}/',
    tramiteTasks: 'tramite-tasks/{idTramite}/',
    microprocessTasks: 'microprocess-tasks/{idTask}/',
    categoryReports: 'category-reports/{idCategory}/',
    filterReportParameter: 'filter-report-parameter/{idReport}/',
    statusExpediente: 'status-expediente/{idStatus}/',
    filterTramiteParameter: 'filter-tramite-parameter/{idTramite}/',
    generateRecordCover: 'generate-record-cover/{idDocumento}/',
    tramiteUserProcess: 'tramite-user-process/{idProcess}/',
    processUser: 'process-user/{idCategory}/',
    categoryUser: 'category-user/',
    instanceSecondaryWorkflow: 'instance-secondary-workflow/{id}/',
    instanceSecondaryCancelation: 'instance-secondary-cancelation/',
    documentAssociateProcess: 'document-associate-process/',
    associateProcess: 'associate-process/',
    associatedTask: 'associated-task/{idTask}/',
    attachedDocument: 'attached-document/{id}/',
    downloadAttachedDocument: 'download-attached-document/{id}/',
    consecutiveActDocument: 'consecutive-act-document/',
    adminGeneric: 'admin-generic',
    allTramiteProcess: 'all-tramite-process/{id}/',
    defaultDynamicTaskForm: 'default-dynamic-task-form/{idForm}/',
    tramiteProcessWithoutStructure: 'tramite-process-without-structure/{idProcess}/',
    reportTask: 'report_task/',
    adminSerie: 'admin-serie/{id}/',
    adminSubSerie: 'admin-subserie/{id}/',
    adminTypeDocument: 'admin-type-document/{id}/',
    adminDocument: 'admin-document/{id}/',
    adminDocumentGeneration: 'admin-document-generation/{id}/',
    adminDocumentPreviewDocument: 'admin-preview-document/{id}/',
    chargeUsers: 'charge-users/{idCharge}/',
    changeUserPassword: 'change-user-password/',
    observationProcess: 'observation-process/{id}/',
    typeService: 'type-service/{id}/',
    processTitles: 'process-titles/{id}/',
    titles: 'titles/',
    stageInstanceTimes:'stage-instance-times/{id}/',
    searchDependencie: 'search-dependencies/',
    filterReportParameterInstance: 'filter-report-parameter-instance/{id}/',
    categoryReportsInstance: 'category-reports-instance/{idCategory}/',
    searchProcedureModalInfo: 'search-dynamic-modal/',
  }
};



// WEBPACK FOOTER //
// ./src/api-endpoints.ts